import { gql } from '@apollo/client';

export const ADD_BOOK_TO_SHELF = gql`
  mutation AddBookToShelf($bookId: Int!) {
    addBookToShelf(bookId: $bookId) {
      id
      title
      is_on_shelf
    }
  }
`;

export const REMOVE_BOOK_FROM_SHELF = gql`
  mutation RemoveBookFromShelf($bookId: Int!) {
    removeBookFromShelf(bookId: $bookId) {
      id
      title
      is_on_shelf
    }
  }
`;
